export default {
  MY_TIME_OFF: {
    TITLE: 'Mes congés',
    SUMMARY: 'Affichez, modifiez et demandez des congés.'
  },
  CREATE_REQUEST: 'Créer une requête de congé',
  TIME_OFF_ON: '<0>{{vacationTypeName}}</0> le <1></1>',
  APPROVED: 'Approuvé',
  COMMENT: `commentaire`,
  COMMENTS: `commentaires`,
  NO_TIME_OFF: `Aucun congé à afficher.`
}
